import { objectService } from '@/modules/common/api';
import { apiClient } from '@/provider';
import { prepareObject } from '@/provider/utils';
import connectionScheme from './connection.graphql';

export default {
  ...objectService,
  fetchConnectionSchemaId() {
    return apiClient
      .query({
        query: connectionScheme.fetchConnectionSchemaId
      })
      .then(r => r.data.schemata[0]?.id || '');
  },
  async fetch(id) {
    const res = await apiClient.query({
      query: connectionScheme.fetch,
      variables: {
        id
      },
      fetchPolicy: 'no-cache'
    });
    return prepareObject(res.data.object);
  },
  create({ name, description, enabled, schemaId }) {
    return apiClient
      .mutate({
        mutation: connectionScheme.create,
        variables: {
          input: {
            object: {
              name,
              description,
              enabled,
              schemaId
            }
          }
        }
      })
      .then(r => prepareObject(r.data?.createObject?.object));
  },
  update(id, { name, description }) {
    return apiClient.mutate({
      mutation: connectionScheme.update,
      variables: {
        id,
        name,
        description
      }
    });
  }
};
